import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import ReactsCard from "../components/ui/ReactsCard";
import {useOrganization} from "../components/organizations/organization-context";
import {Members} from "../components/members/Members";
import {CrossOrganizationSearch} from "../components/_shared/CrossOrganizationSearch";
import Button from "@material-ui/core/Button";
import {useNavigate} from 'react-router-dom';


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(4)
    },
    action: {
        justifyContent: 'flex-end'
    },
    table: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'center'
    }
}));

const MembersView = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [currentOrganization] = useOrganization();
    const navigate = useNavigate();

    const moveMember = () => {
        navigate('/members/move?returnUrl=/members');
    };

    return (
        <ReactsCard title={t('Members.Title')} className={classes.root}>
            <div className={classes.table}>
                <CrossOrganizationSearch organization={currentOrganization}>
                    <CrossOrganizationSearch.Action>
                        <Button variant="contained"
                                color="primary"
                                size="medium"
                                onClick={moveMember}>
                            {t('Members.MoveMembers.Title')}
                        </Button>
                    </CrossOrganizationSearch.Action>
                    <CrossOrganizationSearch.Body>
                        <Members/>
                    </CrossOrganizationSearch.Body>
                </CrossOrganizationSearch>
            </div>
        </ReactsCard>
    )
};

export default MembersView;
